var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('product-wizard-provider',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var product = ref.product;
var addProduct = ref.addProduct;
var isLoading = ref.isLoading;
var campaign = ref.campaign;
return [_c('product-view',{attrs:{"product":product,"campaign":campaign,"is-loading":isLoading},on:{"add-product":addProduct}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }